export const lightTheme = {
  //background: `url('./bg1.png')`,
  backgroundImage:
    'radial-gradient(circle at 18% 22%, rgba(244, 211, 94, 0.22), transparent 30%), radial-gradient(circle at 78% 18%, rgba(20, 83, 45, 0.18), transparent 28%), linear-gradient(140deg, #f4f1ea 0%, #d7d1c7 46%, #9aa49f 100%)',
  backgroundAttachment: 'fixed', // For parallax effect
  backgroundSize: 'cover',
  backgroundPosition: 'center top',
  backgroundColor: '#fff',
  
  color: '#121212',
  accentColor: 'rgb(39, 55, 70)',
  chronoTheme: {
    cardBgColor: 'white',
    cardForeColor: 'black',
    titleColor: '#121212',
  },
  timelineLineColor: '#ccc',
  cardBackground: '#fff',
  cardFooterBackground: '#f7f7f7',
  cardBorderColor: '#00000020',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#121212',
};

export const darkTheme = {
  backgroundImage:
    'radial-gradient(circle at 18% 24%, rgba(244, 211, 94, 0.14), transparent 26%), radial-gradient(circle at 78% 18%, rgba(20, 83, 45, 0.18), transparent 28%), linear-gradient(140deg, #071018 0%, #1c2630 45%, #3a4953 100%)',
  backgroundAttachment: 'fixed',
  backgroundSize: 'cover',
  backgroundPosition: 'center top',
  backgroundColor: '#060606',
  color: '#eee',
  accentColor: 'rgb(39, 55, 70)',
  chronoTheme: {
    cardBgColor: '#1B1B1B',
    cardForeColor: '#eee',
    titleColor: '#fff',
  },
  timelineLineColor: '#444',
  cardBackground: '#060606',
  cardFooterBackground: '#181818',
  cardBorderColor: '#ffffff20',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#fefefe',
};
